module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Badass Body Diet: The Breakthrough Diet and Workout for a Tight Booty, Sexy Abs, and Lean Legs")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/9780062390974_template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "part",
      "title": "PART 1"
    }
  }, [_c('div', {
    staticClass: "full"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/partbg.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('p', {
    staticClass: "PART_NUM"
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#p1"
    }
  }, [_c('span', {
    staticClass: "blue2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART 1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "PART_line"
  }, [_vm._v("______________")]), _vm._v(" "), _c('p', {
    staticClass: "PART_TTL"
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#p1"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GET YOUR REAR IN GEAR")])])]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db7bca0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062390974_P1.vue
// module id = 72
// module chunks = 0